export const getDistribution = state => state.distribution.data;
export const distributionLoading = state => state.distribution.isLoading;
